<template>
  <div>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">FAQ’s</h2>
              <p class="listing-page-desc">Insurance Bazaar</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img
              class="img-fluid"
              alt="icon"
              :src="require('@/assets/images/claim-policy-right-img.svg')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
      <div class="container multistep-box">
      <!-- First FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading active" role="tab" id="headingOne">
            <div class="collapsible-link">
              <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                Q:- What is an insurance bazaar?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
            <div class="panel-body">
              Insurance Bazaar is a marketplace for all your insurance needs; it provides a paperless journey between you and the insurance provider; you can perform all the steps of buying an insurance policy from the comfort of your home. You can file a claim and service your policy from within the app as well.
            </div>
          </div>
        </div>
      <!-- Second FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwo">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Q:- Why Should I use Insurance Bazaar?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
            <div class="panel-body">
              Insurance Bazaar removes all the hassles for you whether it is buying a policy, requesting policy servicing or filing a claim. It also provides a comparison of the best available plans and coverages in Pakistan.
            </div>
          </div>
        </div>
      <!-- Third FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingThree">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Q:- What types of Insurance do you offer on your application?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
            <div class="panel-body">
              At the moment we are offering the following products from different companies
              <ul>
                <li>Life Insurance</li>
                <li>Motor Insurance</li>
                <li>Health Insurance</li>
                <li>Travel</li>
                <li>Personal Accident Insurance</li>
                <li>Home Insurance</li>
              </ul>
            </div>
          </div>
        </div>
      <!-- Fourth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingFour">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                Q:- What are my payment options?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
            <div class="panel-body">
              Your payment options are credit card and debit card at the moment.
            </div>
          </div>
        </div>
      <!-- Fifth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingFifth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFifth" aria-expanded="false" aria-controls="collapseFifth">
                Q:- How do I choose a policy that is right for me?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseFifth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFifth">
            <div class="panel-body">
              You can choose the policy that is right for you by comparing the different policies and reading the information provided in the accompanying brochures.
            </div>
          </div>
        </div>
      <!-- Sixth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingSixth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSixth" aria-expanded="false" aria-controls="collapseSixth">
                Q:- What are insurance company ratings?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseSixth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSixth">
            <div class="panel-body">
              Insurance companies are rated by independent bodies on different parameters.
            </div>
          </div>
        </div>
      <!-- Seventh FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingSeventh">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSeventh" aria-expanded="false" aria-controls="collapseSeventh">
                Q:- How do I cancel my policy?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseSeventh" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeventh">
            <div class="panel-body">
              You can request to cancel your policy from the policy servicing menu of the Insurance Bazaar APP.
            </div>
          </div>
        </div>
      <!-- Eigth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingEigth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseEigth" aria-expanded="false" aria-controls="collapseEigth">
                Q:- My promo code doesn’t work?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseEigth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEigth">
            <div class="panel-body">
              Your promo may have already been used or may have been expired.
            </div>
          </div>
        </div>
      <!-- Ninth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingNinth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseNinth" aria-expanded="false" aria-controls="collapseNinth">
                Q:- Why is my claim taking so long?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseNinth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingNinth">
            <div class="panel-body">
              Claims are processed by the insurance company and they have their own criteria for verifying and processing claims.
            </div>
          </div>
        </div>
      <!-- Tenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTenth" aria-expanded="false" aria-controls="collapseTenth">
                Q:- Why was my policy rejected?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTenth">
            <div class="panel-body">
              Your policy may have been rejected due to a number of reasons the most prevalent of which is the upload of incorrect information, KYC failure etc.
            </div>
          </div>
        </div>
      <!-- Eleventh FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingEleventh">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseEleventh" aria-expanded="false" aria-controls="collapseEleventh">
                Q:- What is verisys?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseEleventh" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEleventh">
            <div class="panel-body">
              Verisys is NADRA’s system of ID verification. The insurance company verifies customer ID before policy issuance.
            </div>
          </div>
        </div>
      <!-- Twelveth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwelveth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwelveth" aria-expanded="false" aria-controls="collapseTwelveth">
                Q:- How will I make sure that you won’t misuse my signatures or CNIC?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwelveth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwelveth">
            <div class="panel-body">
              Your personal details are saved in an encrypted database, and when scanned your CNIC and signatures will be scanned it will be digitally watermarked.
            </div>
          </div>
        </div>
      <!-- Thirteenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingThirteenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThirteenth" aria-expanded="false" aria-controls="collapseThirteenth">
                Q:- Why are my policy numbers different?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseThirteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThirteenth">
            <div class="panel-body">
              Each insurance company and Insurance product has its own format for the policy number.
            </div>
          </div>
        </div>
      <!-- Fourteenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingFourteenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFourteenth" aria-expanded="false" aria-controls="collapseFourteenth">
                Q:- What is the need for uploading these images or document while claiming intimation?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseFourteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFourteenth">
            <div class="panel-body">
              These images or supporting documents help in expediting the claim process.
            </div>
          </div>
        </div>
      <!-- Fifteenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingFifteenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFifteenth" aria-expanded="false" aria-controls="collapseFifteenth">
                Q:- What is a pre-policy document?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseFifteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFifteenth">
            <div class="panel-body">
              The pre-policy document is a confirmation that you have placed an order for the policy from Insurance Bazaar.
            </div>
          </div>
        </div>
      <!-- Sixteenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingSixteenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSixteenth" aria-expanded="false" aria-controls="collapseSixteenth">
                Q:- What is an endorsement/policy servicing?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseSixteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSixteenth">
            <div class="panel-body">
              Any change in the insurance policy is called an endorsement.
            </div>
          </div>
        </div>
      <!-- Seventeenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingSeventeenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSeventeenth" aria-expanded="false" aria-controls="collapseSeventeenth">
                Q:- How can I request policy servicing?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseSeventeenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeventeenth">
            <div class="panel-body">
              You can request policy servicing from the account menu of the Insurance Bazaar APP. Select your active policy, choose servicing type and enter the new details, Insurance company have the right to accept or reject your request.
            </div>
          </div>
        </div>
      <!-- Eigtheenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingEigtheenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseEigtheenth" aria-expanded="false" aria-controls="collapseEigtheenth">
                Q:- The scanner isn’t identifying my card details.
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseEigtheenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEigtheenth">
            <div class="panel-body">
              You can manually input the card details if your card isn’t auto scanned.
            </div>
          </div>
        </div>
      <!-- Nineteenth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingNineteenth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseNineteenth" aria-expanded="false" aria-controls="collapseNineteenth">
                Q:- The scanner puts forth false details.
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseNineteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingNineteenth">
            <div class="panel-body">
              Please rectify the mistakes and then proceed.
            </div>
          </div>
        </div>
      <!-- Twentyth FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentyth">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyth" aria-expanded="false" aria-controls="collapseTwentyth">
                Q:-	What are the perks of being a ‘founder member’?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentyth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyth">
            <div class="panel-body">
              Being a founder member gets you perks such as the founder member badge; free accident and hospitalization cover for one year and a promo for 10% off your next purchase.
            </div>
          </div>
        </div>
      <!-- Twentyone FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentyone">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyone" aria-expanded="false" aria-controls="collapseTwentyone">
                Q:- How do I file a claim?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentyone" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyone">
            <div class="panel-body">
              Filing a claim with an insurance bazaar is very easy; just go to claims, select policy and then file a claim with all the required documents and details.
            </div>
          </div>
        </div>
      <!-- Twentytwo FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentytwo">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentytwo" aria-expanded="false" aria-controls="collapseTwentytwo">
                Q:- How long will my policy remain in effect?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentytwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentytwo">
            <div class="panel-body">
              Every policy has a different expiry date and it remains in effect till that expiry date.
            </div>
          </div>
        </div>
      <!-- Twentythree FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentythree">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentythree" aria-expanded="false" aria-controls="collapseTwentythree">
                Q:- What is premium?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentythree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentythree">
            <div class="panel-body">
              It is the amount paid by the policy owner for the purchase of a life insurance policy. Subsequently, renewal premiums are paid by due dates or within the grace period to ensure that the policy remains in force and that the benefits available under the policy remain intact.
            </div>
          </div>
        </div>
      <!-- Twentyfour FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentyfour">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyfour" aria-expanded="false" aria-controls="collapseTwentyfour">
                Q:- What is a policy document?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentyfour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyfour">
            <div class="panel-body">
              A policy document is printed and signed an insurance contract between the policy owner and insurance Bazaar. Policy documents consist of the policy schedule, stamp duty page, standard policy conditions and supplementary contracts (if provided for in the policy).
            </div>
          </div>
        </div>
      <!-- Twentyfive FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentyfive">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyfive" aria-expanded="false" aria-controls="collapseTwentyfive">
                Q:- What is a total loss?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentyfive" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyfive">
            <div class="panel-body">
              If the insurance company deems that the cost of the repair of an accidental vehicle is more than 50% of the vehicle’s current market value, it is likely that such vehicle will be declared as Total Loss as it is uneconomical to get the vehicle repaired.
            </div>
          </div>
        </div>
      <!-- Twentysix FAQ -->
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="headingTwentysix">
            <div class="collapsible-link">
              <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentysix" aria-expanded="false" aria-controls="collapseTwentysix">
                Q:- Can the insurance provider cancel my policy?
                <!-- <span class="Qmark">?</span> -->
                <span class="plus-icon">&plus;</span>
                <span class="minus-icon">&minus;</span>
              </a>
            </div>
          </div>
          <div id="collapseTwentysix" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentysix">
            <div class="panel-body">
              Yes, the insurance company reserves right to cancel the policy at any time.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FAQs'
  };
</script>

<style scoped>
  .panel-default{
    background-color: rgba(249, 252, 253, 0.7);
    margin-bottom: 28px;
  }
  .panel-body{
    font-family: "Avenir Book";
    font-size: 14px;
    text-align: left;
    color: #787b7c;
    padding: 15px;
  }
  .collapsible-link a{
    margin: 0 0 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Faqs.vue